export default "__VITE_ASSET__BOci84HV__"